define([
  "jquery",
  "knockout"],
function($, ko) {

  "use strict";

  // Uses a foreach binding, but clears the existing content first: http://stackoverflow.com/a/13803122
  ko.bindingHandlers.replaceServerTemplate = {
    init: function(element, valueAccessor) {
      $(element).html("");
      return ko.bindingHandlers.template.init(element, valueAccessor);
    },
    update: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
      return ko.bindingHandlers.template.update(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
    }
  };

});
